var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 134,
    viewBox: "0 0 133 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5137_19275)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 65,
    r: 47.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6515 64.837C65.3195 64.837 64.0006 64.5743 62.7703 64.064C61.54 63.5537 60.4224 62.8057 59.4814 61.863C58.5405 60.9202 57.7948 59.8011 57.2869 58.5698C56.779 57.3384 56.5189 56.019 56.5215 54.687V40.957C56.6042 38.3268 57.7071 35.8319 59.5969 34.0006C61.4867 32.1693 64.015 31.1453 66.6465 31.1453C69.278 31.1453 71.8063 32.1693 73.6961 34.0006C75.5859 35.8319 76.6888 38.3268 76.7715 40.957V54.687C76.7741 56.0182 76.5144 57.3368 76.0071 58.5674C75.4998 59.7981 74.755 60.9168 73.8151 61.8594C72.8752 62.8021 71.7588 63.5502 70.5296 64.0611C69.3005 64.5721 67.9826 64.8357 66.6515 64.837ZM66.6515 35.837C65.2927 35.837 63.9894 36.3761 63.0276 37.336C62.0658 38.2959 61.5242 39.5982 61.5215 40.957V54.687C61.5798 56.0071 62.1453 57.2538 63.1 58.1672C64.0547 59.0807 65.3251 59.5906 66.6465 59.5906C67.9679 59.5906 69.2383 59.0807 70.193 58.1672C71.1477 57.2538 71.7132 56.0071 71.7715 54.687V40.957C71.7689 39.5999 71.2286 38.2992 70.269 37.3396C69.3094 36.3799 68.0086 35.8397 66.6515 35.837Z",
    fill: "#F89358"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5112 43.177H43.4912C38.9127 43.177 35.2012 46.8886 35.2012 51.467V80.797C35.2012 85.3754 38.9127 89.087 43.4912 89.087H87.5112C92.0896 89.087 95.8012 85.3754 95.8012 80.797V51.467C95.8012 46.8886 92.0896 43.177 87.5112 43.177Z",
    fill: "#F89358"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6217 47.937H45.9317C41.9718 47.937 38.7617 51.1471 38.7617 55.107V77.257C38.7617 81.2169 41.9718 84.427 45.9317 84.427H88.6217C92.5816 84.427 95.7917 81.2169 95.7917 77.257V55.107C95.7917 51.1471 92.5816 47.937 88.6217 47.937Z",
    fill: "#FFB762"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1417 43.177H44.4117C41.2913 43.177 38.7617 45.7066 38.7617 48.827V60.207C38.7617 63.3274 41.2913 65.857 44.4117 65.857H90.1417C93.2621 65.857 95.7917 63.3274 95.7917 60.207V48.827C95.7917 45.7066 93.2621 43.177 90.1417 43.177Z",
    fill: "#F89358"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3709 57.7271H67.3009C65.5944 57.7271 64.2109 59.1105 64.2109 60.8171V66.8871C64.2109 68.5936 65.5944 69.9771 67.3009 69.9771H67.3709C69.0775 69.9771 70.4609 68.5936 70.4609 66.8871V60.8171C70.4609 59.1105 69.0775 57.7271 67.3709 57.7271Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0327 91.6054L50.7399 90.0819L44.0327 88.453L42.4517 82.2727L40.7365 88.4146L34.0293 89.9573L40.6791 91.5574L42.3463 98.0731L44.0327 91.6054Z",
    fill: "#00C65E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3203 35.8371L95.8003 35.0371L92.2803 34.1971L91.4603 30.9871L90.5903 34.2071L87.0703 35.0171L90.5403 35.8371L91.4103 39.2371L92.3203 35.8371Z",
    fill: "#FFB762"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5137_19275",
    x: 0,
    y: 0.5,
    width: 133,
    height: 133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_5137_19275"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.211765 0 0 0 0 0.227451 0 0 0 0 0.270588 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5137_19275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5137_19275",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.ed060227155a268c814437e3660827d9.svg";
export { ForwardRef as ReactComponent };